import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IntubationService } from '../../intubation/services/intubation.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import * as actions from '../store/options.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setDistanceUnitOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const intubationService = new IntubationService(serviceId)
  try {
    const response: IOptionsResponse = yield call([intubationService, intubationService.getDistanceUnitOptions])
    const { entity } = response
    yield put(actions.setDistanceUnitOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setDistanceUnitOptions() error: ${e}`))
  }
}
export function* setDistanceUnitOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setDistanceUnitOptions)
}
